//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {dataList, listNum} from '@/mock/timu.js'
import surveyList from '@/pages/list/Index.vue'
import { request } from '@/tools/index.js'
import {isIphonex} from "@runwork/runwork-help";
export default {
  data() {
    return {
      searchKey: '',
      dataList: [],
      nodata: false,
      tabData: ['未完成', '已完成', '已过期'],
      currentIndex: 0,
      // 搜索结果的展示
      isShowRes: false,
      // 过期列表
      expireList: [],
      // 已完成列表
      finishedList: [],
      //未完成列表
      notFinishedList:[]
    }
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2 () {
      return isIphonex() && this.platform === 2
    },
    status () {
      switch(this.currentIndex){
        case 0 :
          return 10;
        case 1 :
          return 20;
        case 2 :
          return 30;
        default : 
          return 10;
      }
    }
  },
  components: {
    surveyList
  },
  mounted() {
    this.$refs['searchInput'].focus()
    this.isShowRes = false
  },
  watch: {
    currentIndex (n) {
      this.getDataList(n)
    }
  },
  methods: {
    closeSearchView () {
      this.searchKey = ''
      this.dataList = []
      this.isShowRes = false
      this.nodata = false
      this.currentIndex = 0
    },
    search () {
      setTimeout(() => {
        this.searchHandle()
      }, 500)
    },
    getDataList (n) {
      if (n == 0) {
        this.dataList = this.notFinishedList
      } else if (n == 1) {
        this.dataList = this.finishedList
      } else {
        this.dataList = this.expireList
      }
      if (!this.dataList.length) {
        this.nodata = true
      } else {
        this.nodata = false
      }
    },
    async searchHandle() {
      const searchName = this.searchKey.trim()
      if (!searchName) {
        return
      }
      this.loading = true
      this.nodata = false
      const userCode = this.user.ldap
      const params = {
        userCode,
        searchName
      }
      const {finishedCount,notFinishedCount,expireCount,finishedList,notFinishedList,expireList} = await request('getSearchData', params)
      this.notFinishedList = notFinishedList || []
      this.finishedList = finishedList || []
      this.expireList = expireList || []
      this.tabData = [
        `未完成(${notFinishedCount})`, 
        `已完成(${finishedCount})`, 
        `已过期(${expireCount})`
      ]
      this.getDataList(this.currentIndex)
      this.isShowRes = true 
    }
  }
}
